const es = {
    CLONE: 'CLONAR',
    SHOW_ACTUATION: 'VER ACTUACIÓN',
    SHOW_ACTUATIONS: 'VER ACTUACIONES',
    ANULATE: 'ANULAR',
    OPEN: 'ABRIR',
    VIEW: 'VER',
    SHOW_INFO: 'VER INFO',
    VIDEO: 'VIDEO',
    REMOVE_FILTERS: 'QUITAR FILTROS'
};

export default es;